import React, { useCallback} from 'react';

import { Accordion, AccordionSummary, AccordionDetails, Typography, Box, Button, TextField, Alert } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

import GenericDetailsTable from '../Layout/Table/GenericDetailsTable';


function MetersListInfo({ details }) {

    const formatDateTime = useCallback((isoString) => {
            const date = new Date(isoString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
    }, []);

    const detailsList = [
        { key: 'status', label: 'Status',
            render: (item) => (item.status === 'Pending' ? 'NOT YET ACTIVE (Will sync on next connection)' : item.status),
        },
        {
        key: 'source',
        label: 'Origin of meter list',
        render: (item) => (item.list.source === 'ImportedJSON' ? 'Edited' : item.list.source),
        },
        { key: 'filename', label: 'Source filename', render: (item) => item.list.filename },
        { key: 'created', label: 'Created', render: (item) => formatDateTime(item.list.created) },
        { key: 'count', label: 'Number of Meters', render: (item) => item.list.entries.length },
    ];


    return (
        <Accordion defaultExpanded={true}> 
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant="h7">GENERAL INFORMATION</Typography>
            </AccordionSummary>
            <AccordionDetails>
                {details ? (
                    <GenericDetailsTable
                        detailsValue={details}
                        detailsList={detailsList} />
                ) : (
                    <Alert severity="info" sx={{ display: 'flex', alignItems: 'center', borderRadius: 2 }}>
                    This gateway does not have a meter list yet. You can add entries manually, import a PLT file or save a Meters Scan as list.
                    </Alert>
                )}
                {details && details.gatewayId === null && details.locationId && (
                    <Alert severity="info" sx={{ display: 'flex', alignItems: 'center', borderRadius: 2 }}>
                    This meters list is assigned to this gateway's Location. Modifing the list on this page will change only the selected gateway list.
                    </Alert>
                )}
            </AccordionDetails>
        </Accordion>
    );
}

export default MetersListInfo;
